const ButtonLoaderSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="loader"
  >
    <path
      className="spinner-bg-outer"
      d="M9 1C10.0506 1 11.0909 1.20693 12.0615 1.60896C13.0321 2.011 13.914 2.60028 14.6569 3.34315C15.3997 4.08601 15.989 4.96793 16.391 5.93853C16.7931 6.90914 17 7.94943 17 9C17 10.0506 16.7931 11.0909 16.391 12.0615C15.989 13.0321 15.3997 13.914 14.6569 14.6569C13.914 15.3997 13.0321 15.989 12.0615 16.391C11.0909 16.7931 10.0506 17 9 17C7.94942 17 6.90914 16.7931 5.93853 16.391C4.96793 15.989 4.08601 15.3997 3.34315 14.6569C2.60028 13.914 2.011 13.0321 1.60896 12.0615C1.20693 11.0909 1 10.0506 1 9C1 7.94942 1.20693 6.90914 1.60896 5.93853C2.011 4.96793 2.60028 4.08601 3.34315 3.34314C4.08602 2.60028 4.96793 2.011 5.93853 1.60896C6.90914 1.20693 7.94943 1 9 1L9 1Z"
      stroke="#ACCCFB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="spinner-bg-overlay"
      d="M9 1C10.0506 1 11.0909 1.20693 12.0615 1.60896C13.0321 2.011 13.914 2.60028 14.6569 3.34315C15.3997 4.08601 15.989 4.96793 16.391 5.93853C16.7931 6.90914 17 7.94943 17 9"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlackSpinLoaderSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="loader"
  >
    <path
      d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
      opacity=".10"
    />
    <path
      d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
      className="spinner-bg-overlay"
    />
  </svg>
);

export default ButtonLoaderSvg;
